class MetaPixel {
  inInitiated: boolean = false;
  actualWindow: typeof window & { fbq?: (name: string, event?: any, data?: any) => any } = window;
  init(code: string) {
    if (code !== undefined) this.inInitiated = true;
    this.actualWindow = window;
  }

  pageView() {
    console.log("pageView");
    this.inInitiated && this.actualWindow.fbq && this.actualWindow.fbq("pageView");
  }

  track(event: string, data: any) {
    // this.inInitiated && ReactPixel.track(event, data);
  }

  trackCustom(event: string, data: any) {
    console.log(event);
    this.inInitiated && this.actualWindow.fbq && this.actualWindow?.fbq("trackCustom", event, data);
    // this.inInitiated && ReactPixel.trackCustom(event, data);
  }

  trackSingle(event: string, data: any) {
    // this.inInitiated && ReactPixel.trackSingle(event, data);
  }

  trackSingleCustom(event: string, data: any) {
    // this.inInitiated && ReactPixel.trackSingleCustom(event, data);
  }
}
export default new MetaPixel();
